import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import LoadingProgress from '../components/LoadingProgress'
import ErrorMessage from '../components/ErrorMessage'

import { fetchNotificationSettings, updateNotificationSettings } from '../actions/notificationSettings'

import '../styles/ComunicacionesView.css'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const LISTS = [
  {
    field: 'TicketEmails',
    title: 'Tickets de soporte',
    icon: 'fas fa-receipt',
    description: 'Estos emails recibirán una notificación cuando se abra un ticket de soporte y en cada cambio de estado (en revisión, en incidencia, en reparación, resuelto, cerrado).',
  },
  {
    field: 'IncidenceEmails',
    title: 'Incidencias',
    icon: 'fas fa-exclamation-triangle',
    description: 'Estos emails recibirán una notificación cuando se abra una incidencia y en cada cambio de estado (en revisión, en reparación, resuelta), además de las notas de reparación.',
  },
]

class ComunicacionesView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      inputs: { TicketEmails: '', IncidenceEmails: '' },
      inputErrors: { TicketEmails: null, IncidenceEmails: null },
    }
  }

  componentDidMount() {
    this.props.fetchNotificationSettings()
  }

  getEmails(field) {
    const { settings } = this.props
    return (settings && settings[field]) || []
  }

  handleInputChange(field, value) {
    this.setState(prev => ({
      inputs: { ...prev.inputs, [field]: value },
      inputErrors: { ...prev.inputErrors, [field]: null },
    }))
  }

  setInputError(field, message) {
    this.setState(prev => ({
      inputErrors: { ...prev.inputErrors, [field]: message }
    }))
  }

  handleAdd(field) {
    const email = this.state.inputs[field].trim().toLowerCase()

    if (!email) return

    if (!EMAIL_REGEX.test(email)) {
      this.setInputError(field, 'Introduce un email válido')
      return
    }

    const emails = this.getEmails(field)
    if (emails.includes(email)) {
      this.setInputError(field, 'Este email ya está en la lista')
      return
    }

    this.props.updateNotificationSettings({ [field]: [...emails, email] })
    this.setState(prev => ({
      inputs: { ...prev.inputs, [field]: '' },
      inputErrors: { ...prev.inputErrors, [field]: null },
    }))
  }

  handleRemove(field, email) {
    const emails = this.getEmails(field).filter(e => e !== email)
    this.props.updateNotificationSettings({ [field]: emails })
  }

  renderCard(list) {
    const { saving } = this.props
    const emails = this.getEmails(list.field)
    const inputValue = this.state.inputs[list.field]
    const inputError = this.state.inputErrors[list.field]

    return (
      <div key={list.field} className="comms-card">
        <div className="comms-card-header">
          <h2><i className={list.icon}></i> {list.title}</h2>
          <span className="comms-card-count">{emails.length} {emails.length === 1 ? 'email' : 'emails'}</span>
        </div>
        <p className="comms-card-description">{list.description}</p>

        <div className="comms-add-row">
          <input
            type="email"
            className={`comms-add-input ${inputError ? 'has-error' : ''}`}
            placeholder="email@ejemplo.com"
            value={inputValue}
            disabled={saving}
            onChange={e => this.handleInputChange(list.field, e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') this.handleAdd(list.field) }}
          />
          <button
            className="comms-add-btn"
            onClick={() => this.handleAdd(list.field)}
            disabled={saving || !inputValue.trim()}
          >
            <i className="fas fa-plus"></i> Añadir
          </button>
        </div>
        {inputError && <div className="comms-input-error">{inputError}</div>}

        {emails.length === 0 ? (
          <div className="comms-empty">
            <i className="fas fa-envelope-open"></i>
            <p>No hay emails configurados</p>
            <p className="comms-empty-hint">No se enviará ninguna notificación hasta que añadas al menos un email</p>
          </div>
        ) : (
          <ul className="comms-email-list">
            {emails.map(email => (
              <li key={email} className="comms-email-item">
                <span className="comms-email-address">
                  <i className="fas fa-envelope"></i> {email}
                </span>
                <button
                  className="comms-remove-btn"
                  title="Eliminar"
                  disabled={saving}
                  onClick={() => this.handleRemove(list.field, email)}
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    )
  }

  render() {
    const { error, loading, saving, settings, role, type } = this.props

    // Only ADMIN + MASTER can see this view
    if (role !== 'ADMIN' || type !== 'MASTER') {
      return (
        <div className="comms-container">
          <div className="comms-empty">
            <i className="fas fa-lock"></i>
            <p>No tienes permisos para acceder a esta página</p>
          </div>
        </div>
      )
    }

    return (
      <div className="comms-container">
        {error && <ErrorMessage message={typeof error === 'string' ? error : (error.message || 'Se ha producido un error')} />}

        <div className="comms-header">
          <div className="comms-header-content">
            <div className="comms-header-text">
              <h1><i className="fas fa-envelope"></i> Comunicaciones</h1>
              <p>Configura los emails que recibirán las notificaciones de tickets de soporte e incidencias del SAT</p>
            </div>
            {saving && (
              <div className="comms-saving">
                <i className="fas fa-circle-notch fa-spin"></i> Guardando...
              </div>
            )}
          </div>
        </div>

        {loading && !settings ? (
          <LoadingProgress />
        ) : (
          <div className="comms-cards">
            {LISTS.map(list => this.renderCard(list))}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  settings: state.notificationSettings.settings,
  loading: state.notificationSettings.loading,
  saving: state.notificationSettings.saving,
  error: state.notificationSettings.error,
  role: state.auth.role,
  type: state.auth.type,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchNotificationSettings,
  updateNotificationSettings,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ComunicacionesView)
